"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridFutureProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const GridTradingUtils_1 = require("./GridTradingUtils");
const trade_utils_lib_1 = require("trade_utils_lib");
const BinanceFutureMarginCalculator_1 = require("../CommonUtils/FutureUtils/BinanceFutureMarginCalculator");
const ByBitFutureMarginCalculator_1 = require("../CommonUtils/FutureUtils/ByBitFutureMarginCalculator");
// import { MXCFutureMarginCalculator } from "../CommonUtils/FutureUtils/MXCFutureMarginCalculator";
const FTXFutureMarginCalculator_1 = require("../CommonUtils/FutureUtils/FTXFutureMarginCalculator");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const BitgetFutureMarginCalculator_1 = require("../CommonUtils/FutureUtils/BitgetFutureMarginCalculator");
exports.GridFutureProcessor = {
    useUserParams(trend, top, bottom, count, invest, investPercent, gridType, baseAvailable, quoteAvailable, triggerPrice, stopLostPrice, takeProfitPrice, currentPrice, symbol, market, tradeAPI, botType, leverageRate, investAction, openPriceLimit, updateSignal) {
        var _a, _b;
        const earnCoin = symbol.quote;
        const symbolLeverageConfig = this.useSymbolLeverageConfig(tradeAPI, symbol);
        const [realFee, calcuFee] = this.useFee(tradeAPI);
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top, bottom, gridType, calcuFee, (_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, 150);
        // 获取借贷的币种, 借贷币种的精度, 投资的币种的精度
        const [debtCoin, debtPrecision, earnPrecision] = (0, react_1.useMemo)(() => {
            const debt_coin = symbol.quote;
            const debt_precision = symbol.precision || 0;
            const earn_precision = symbol.precision || 0;
            return [debt_coin, debt_precision, earn_precision];
        }, [symbol.quote, symbol.precision]);
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid(gridType, top, bottom, count, calcuFee, (_b = symbol.precision) !== null && _b !== void 0 ? _b : 0);
        const minInvestInit = GridTradingUtils_1.GridTradingUtils.useMinInvest(botType, trend, earnCoin, gridType, top, bottom, count, symbol, market, tradeAPI, currentPrice, triggerPrice, `${leverageRate}`, calcuFee, updateSignal);
        const minInvest = (0, react_1.useMemo)(() => {
            if (leverageRate) {
                const earnMin = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(new trade_utils_lib_1.SafeDecimal(minInvestInit).div(leverageRate), earnPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(earnMin.mul(leverageRate), earnPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
            }
            return "0";
        }, [minInvestInit, leverageRate, earnPrecision]);
        const earnAvailable = (0, react_1.useMemo)(() => {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, symbol.precision);
        }, [quoteAvailable, symbol]);
        const [debtAvailable, totalAvailable] = (0, react_1.useMemo)(() => {
            const debtAvailble = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(earnAvailable).mul(new trade_utils_lib_1.SafeDecimal(leverageRate - 1)), debtPrecision);
            const totalAvailable = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(earnAvailable).add(new trade_utils_lib_1.SafeDecimal(debtAvailble)), earnPrecision);
            return [debtAvailble, totalAvailable];
        }, [earnAvailable, debtPrecision, earnPrecision, leverageRate]);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investAction, invest, investPercent, totalAvailable, earnPrecision);
        const [earnInvest, debtInvest] = (0, react_1.useMemo)(() => {
            if (!parseInvest) {
                return ["", ""];
            }
            const eInvest = new trade_utils_lib_1.SafeDecimal(parseInvest).div(new trade_utils_lib_1.SafeDecimal(leverageRate));
            const eInvestStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(eInvest, earnPrecision);
            const dInvest = new trade_utils_lib_1.SafeDecimal(parseInvest).sub(new trade_utils_lib_1.SafeDecimal(eInvestStr));
            const dInvestStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(dInvest, debtPrecision);
            return [eInvestStr, dInvestStr];
        }, [parseInvest, leverageRate, earnPrecision, debtPrecision]);
        // 获取借贷日利率和风险率
        const [debtRate, setDebtRate] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            const sub = (0, trade_utils_lib_1.requestWithRetry)(() => {
                return tradeAPI.queryFutureFundingRate(symbol.base, symbol.quote, market);
            }, { name: "queryFutureFundingRate" }).subscribe({
                next: (data) => {
                    if (data) {
                        const rate = new trade_utils_lib_1.SafeDecimal(data.funding_rate || "0")
                            .mul(100)
                            .toSignificantDigits(6, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                            .toString();
                        const ratePercent = rate + `%`;
                        setDebtRate(ratePercent);
                    }
                    else {
                        setDebtRate("--");
                    }
                },
                error: (error) => { },
            });
            return () => sub.unsubscribe();
        }, [tradeAPI, symbol, debtCoin]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: totalAvailable,
            };
            if (parseInvest) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(totalAvailable))) {
                    state.state = "large";
                }
                else if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                    state.state = "small";
                }
            }
            return state;
        }, [parseInvest, minInvest, totalAvailable]);
        const [marginCalculator, isFullPosition] = (0, react_1.useMemo)(() => {
            if (market === TradeAPILib_1.ExchangeID.BINANCE) {
                return [new BinanceFutureMarginCalculator_1.BinanceFutureMarginCalculator(tradeAPI, symbol), false];
            }
            else if (market === TradeAPILib_1.ExchangeID.BYBIT) {
                return [new ByBitFutureMarginCalculator_1.ByBitFutureMarginCalculator(symbol), false];
            }
            // else if (market === ExchangeID.MXC) {
            //     return [new MXCFutureMarginCalculator(symbol), false];
            // }
            else if (market === TradeAPILib_1.ExchangeID.FTX) {
                const ftxCalculator = new FTXFutureMarginCalculator_1.FTXFutureMarginCalculator(symbol);
                ftxCalculator.isFullPosition = true;
                return [ftxCalculator, true];
            }
            else if (market === TradeAPILib_1.ExchangeID.BITGET) {
                return [new BitgetFutureMarginCalculator_1.BitgetFutureMarginCalculator(symbol), false];
            }
            return [undefined, false];
        }, [tradeAPI, market, symbol.symbol]);
        const [exchangeLeverageMaxRate, exchangeLeverageMaxPosition, liquidationPrice] = (0, react_1.useMemo)(() => {
            if (marginCalculator) {
                const result = marginCalculator.getFutureMarginInfo(top, bottom, count, trend, gridType, parseInvest, currentPrice, triggerPrice, leverageRate, realFee, earnAvailable);
                return [result.maxLeverageRate, result.maxPosition, result.liquidationPrice];
            }
            return [undefined, undefined, ""];
        }, [
            top,
            bottom,
            count,
            trend,
            gridType,
            botType,
            parseInvest,
            currentPrice,
            triggerPrice,
            earnCoin,
            leverageRate,
            realFee,
            marginCalculator,
            earnAvailable,
        ]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, count);
            if (!Number(parseInvest)) {
                emptys.push("trading_total_investment");
            }
            return emptys;
        }, [top, bottom, count, parseInvest]);
        let minLeverage;
        let maxLeverage;
        const leverage_ratios = symbolLeverageConfig === null || symbolLeverageConfig === void 0 ? void 0 : symbolLeverageConfig.leverage_ratios;
        if (leverage_ratios && leverage_ratios.length > 0) {
            minLeverage = leverage_ratios[0];
            maxLeverage = leverage_ratios[leverage_ratios.length - 1];
        }
        const result = {
            isFullPosition,
            botType,
            top,
            bottom,
            count,
            invest: parseInvest,
            investPercent: parseInvestPercent,
            gridType,
            baseAvailable,
            quoteAvailable,
            earnCoin,
            trend,
            useAllCoins: false,
            triggerPrice,
            stopLostPrice,
            takeProfitPrice,
            currentPrice,
            symbol,
            fee: realFee,
            emptyErrors,
            investState,
            minInvest,
            profitPerGrid,
            totalAvailable,
            debtCoin,
            earnAvailable,
            debtAvailable,
            liquidation_price: liquidationPrice,
            leverageRate,
            earnPrecision,
            debtPrecision,
            earnInvest,
            debtInvest,
            debt_rate: debtRate,
            calculateFee: calcuFee,
            openPriceLimit,
            minLeverage,
            maxLeverage,
            earnCoinDisplay: earnCoin,
            exchangeLeverageMaxRate,
            exchangeLeverageMaxPosition,
            feeError: "",
            realMaxGrids: calcuGridsMax,
        };
        return result;
    },
    getCreateOrderRequest(params, $st) {
        const baseRequest = GridTradingUtils_1.GridTradingUtils.checkCommonParamsByLocal(params, $st);
        if (params.exchangeLeverageMaxRate) {
            if (params.leverageRate > params.exchangeLeverageMaxRate) {
                throw $st("gird_future_leverage_rate_greater_than_max", { max: params.exchangeLeverageMaxRate });
            }
        }
        if (params.exchangeLeverageMaxPosition) {
            if (new trade_utils_lib_1.SafeDecimal(params.invest).greaterThan(params.exchangeLeverageMaxPosition)) {
                throw $st("EXCEED_MAX_POSITION", { max: params.exchangeLeverageMaxPosition });
            }
        }
        // 开单价格
        const openPrice = params.triggerPrice || params.currentPrice;
        // 判断格子区间
        const priceRangeError = checkPriceRange(openPrice, params.bottom, params.top, params.count, params.gridType, params.trend, params.leverageRate, $st, params.symbol);
        if (priceRangeError) {
            throw priceRangeError;
        }
        // 判断格子密度: 单网格利润率不能低于2倍的手续费
        if (params.profitPerGrid && params.profitPerGrid[0]) {
            const minProfit = params.profitPerGrid[0];
            if (new trade_utils_lib_1.SafeDecimal(minProfit).lessThan(0)) {
                throw $st("grid_profit_per_grid_low", { min: 0 });
            }
        }
        // 判断爆仓价是否在格子区间
        if (params.trend === "long") {
            if (new trade_utils_lib_1.SafeDecimal(params.liquidation_price).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(params.bottom))) {
                throw $st("liquidation_price_need_less_than_bottom");
            }
        }
        else {
            if (new trade_utils_lib_1.SafeDecimal(params.liquidation_price).lessThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(params.top))) {
                throw $st("liquidation_price_need_greater_than_top");
            }
        }
        baseRequest.leverage = new trade_utils_lib_1.SafeDecimal(params.leverageRate).toString();
        baseRequest.base_total_investment = "0";
        baseRequest.quote_total_investment = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(params.earnInvest, params.symbol.precision);
        return baseRequest;
    },
    ///==> 返回值1: realFee, 返回值2: calculate fee
    useFee(tradeAPI) {
        const [realFee, setRealFee] = (0, react_1.useState)("");
        const [calculateFee, setCalculateFee] = (0, react_1.useState)("0");
        (0, react_1.useEffect)(() => {
            if (!tradeAPI) {
                return;
            }
            if (tradeAPI.market === TradeAPILib_1.ExchangeID.BITGET) {
                //taker: "0.0006"
                //maker: "0.0004"
                setRealFee("0.0006");
                setCalculateFee("0.0006");
                return;
            }
            const sub = (0, trade_utils_lib_1.requestWithRetry)(() => {
                return tradeAPI.requestSwapFee();
            }, { name: "requestSwapFee", maxRetryCount: 3 }).subscribe({
                next: (data) => {
                    // 合约用taker fee
                    const taker = new trade_utils_lib_1.SafeDecimal(data.taker).toString();
                    setRealFee(taker);
                    // bybit calculateFee 为0
                    if (tradeAPI.market === TradeAPILib_1.ExchangeID.BYBIT) {
                        setCalculateFee("0");
                    }
                    else {
                        setCalculateFee(taker);
                    }
                },
                error: (error) => {
                    console.log(error);
                },
            });
            return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        }, [tradeAPI]);
        return [realFee, calculateFee];
    },
    useSymbolLeverageConfig(tradeAPI, symbol) {
        const [config, setConfigure] = (0, react_1.useState)(undefined);
        (0, react_1.useEffect)(() => {
            const subscription = (0, trade_utils_lib_1.requestWithRetry)(() => {
                return tradeAPI.queryLeverageSupportedConfig();
            }, { name: "queryLeverageSupportedConfig", maxRetryCount: 2 }).subscribe({
                next: (data) => {
                    setConfigure(data);
                },
                error: () => { },
            });
            return () => subscription.unsubscribe();
        }, [tradeAPI]);
        const symbolLeverageConfig = (0, react_1.useMemo)(() => {
            if (!config || !symbol) {
                return undefined;
            }
            return config[`${symbol.base}_${symbol.quote}`];
        }, [config, symbol]);
        return symbolLeverageConfig;
    },
};
const checkPriceRange = (openPrice, bottom, top, count, gridType, trend, leverage, $st, symbol) => {
    const price = new trade_utils_lib_1.SafeDecimal(openPrice);
    const _bottom = new trade_utils_lib_1.SafeDecimal(bottom);
    const _top = new trade_utils_lib_1.SafeDecimal(top);
    // const _count = new SafeDecimal(count)
    const liquidationRate = new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(leverage)); // 例如: 5倍杠杆, 爆仓率为20% 也就是 1/5.
    // 判断交易所价格限制
    const limitTopPrice = symbol.multiplierUp && new trade_utils_lib_1.SafeDecimal(symbol.multiplierUp).mul(price);
    const limitBottomPrice = symbol.multiplierDown && new trade_utils_lib_1.SafeDecimal(symbol.multiplierDown).mul(price);
    if (trend === "long") {
        const minBottom = price.mul(new trade_utils_lib_1.SafeDecimal(1).sub(liquidationRate));
        const min = limitBottomPrice ? trade_utils_lib_1.SafeDecimal.max(limitBottomPrice, minBottom) : minBottom;
        if (_bottom.lessThan(min)) {
            return $st("grid_future_low_bottom", {
                min: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
        const avgPrice = _bottom.div(new trade_utils_lib_1.SafeDecimal(1).sub(liquidationRate));
        const maxHigh = avgPrice.mul(2).sub(_bottom);
        const max = limitTopPrice ? trade_utils_lib_1.SafeDecimal.min(maxHigh, limitTopPrice) : maxHigh;
        if (_top.greaterThan(max)) {
            return $st("grid_future_high_top", { max: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(max, symbol.precision) });
        }
    }
    else {
        const maxHigh = price.mul(new trade_utils_lib_1.SafeDecimal(1).add(liquidationRate));
        const max = limitTopPrice ? trade_utils_lib_1.SafeDecimal.min(maxHigh, limitTopPrice) : maxHigh;
        if (_top.greaterThan(max)) {
            return $st("grid_future_high_top", { max: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(max, symbol.precision) });
        }
        const avgPrice = _top.div(new trade_utils_lib_1.SafeDecimal(1).add(liquidationRate));
        const minBottom = avgPrice.mul(2).sub(_top);
        const min = limitBottomPrice ? trade_utils_lib_1.SafeDecimal.max(limitBottomPrice, minBottom) : minBottom;
        if (_bottom.lessThan(min)) {
            return $st("grid_future_low_bottom", {
                min: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            });
        }
    }
};
